<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <datepicker-palette
        ref="month"
        v-grow
        v-m-r="16"
        :min="min"
        :max="max"
        :range="range"
        :value="value"
        :month="months[monthFromIdx]"
        :hover-day="hoverDay"
        :first-day-offset="firstDayOffset"
        @input="onInputValue"
        @hover:day="hoverDay = $event"
        @prev-month="monthFromIdx > 0 ? monthFromIdx-- : undefined"
        @next-month="monthFromIdx === months.length - 1 ? undefined : monthFromIdx++"
      />
      <datepicker-palette
        ref="month"
        v-grow
        :min="min"
        :max="max"
        :range="range"
        :value="value"
        :month="months[monthToIdx]"
        :hover-day="hoverDay"
        :first-day-offset="firstDayOffset"
        @input="onInputValue"
        @hover:day="hoverDay = $event"
        @prev-month="monthToIdx > 0 ? monthToIdx-- : undefined"
        @next-month="monthToIdx === months.length - 1 ? undefined : monthToIdx++"
      />
    </div>
  </div>
</template>

<script>
import { boundDate, sortRange } from 'lib/utils/dateRange';

import DatepickerPalette from 'molecules/datetime/DatepickerPalette';

import { getMomentConstructor } from 'lib/utils/date';

const moment = getMomentConstructor();

export default {
  name: 'DatepickerCalendar',
  components: {
    DatepickerPalette,
  },
  props: {
    value: { // { from: moment, to: moment } | moment
      type: Object,
      default: null,
    },
    min: {
      type: Object,
      default: () => moment('01.01.2017', 'DD.MM.YYYY'),
    },
    max: {
      type: Object,
      default: () => moment(),
    },
    firstDayOffset: { // 0 - первый день понедельник, 1 - воскресенье
      type: Number,
      default: 0,
    },
    range: Boolean,
  },
  created() {
    const valueFrom = this.months
      .filter(month => moment(month, 'DD-MM-YYYY')
        .isBefore(this.value.from.clone().add(1, 'second'), 'DD-MM-YYYY'));

    const valueTo = this.months
      .filter(month => moment(month, 'DD-MM-YYYY')
        .isBefore(this.value.to, 'DD-MM-YYYY'));

    this.monthFromIdx = valueFrom.length ? valueFrom.length - 1 : this.months.length - 2;
    this.monthToIdx = valueTo.length ? valueTo.length - 1 : this.months.length - 1;
  },
  data() {
    return {
      hoverDay: null,
      monthFromIdx: 0,
      monthToIdx: 0,
    };
  },
  computed: {
    months() {
      const monthCount = this.max.diff(this.min, 'M');

      return Array.from({ length: monthCount + 1 })
        .map((_, index) => this.min.clone().add(index, 'month').startOf('month'));
    },
    monthFrom() {
      const value = this.months
        .filter(month => moment(month, 'DD-MM-YYYY')
          .isBefore(this.value.from, 'DD-MM-YYYY'));

      return this.$validate.isNotEmptyArray(value) ? value[value.length-1] : this.months[0];
    },
    monthTo() {
      const value = this.months
        .filter(month => moment(month, 'DD-MM-YYYY')
          .isBefore(this.value.to, 'DD-MM-YYYY'));

      return this.$validate.isNotEmptyArray(value) ? value[value.length-1] : this.months[0];
    },
  },
  watch: {
    value(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    onInputValue(value) {
      if (this.range) {
        this.$emit('input', sortRange(value));
      } else {
        this.$emit('input', boundDate(value, [this.min, this.max]));
      }
    },
  },
};
</script>

<style lang="sass" module>
  .container
    --row-height: 36px
    --row-border-weight: 2px
    --daypicker-bg-color: #131212

    .content
      padding: 20px 10px

    .palette
      &:not(:last-child)
        margin-right: 16px

  .content
    +flexbox
    padding: 10px
    border-radius: 10px
    background: var(--daypicker-bg-color)
</style>
